import React, { lazy, Suspense, useEffect, useState } from 'react';
import SectionSkeleton from './sectionskeleton';
import LazySection from 'components/lazySection';
import { useLocation } from 'react-router-dom';

const AboutBanner = lazy(() => import("../components/About/aboutBanner"));
const AboutusAbout = lazy(() => import("../components/About/aboutAbout"));
const AboutFeature = lazy(() => import("../components/About/aboutFeature"));
const AboutMission = lazy(() => import("../components/About/aboutMission"));
const AboutChairmanDetail = lazy(() => import("../components/About/aboutChairmanDetail"));
const AboutTeam = lazy(() => import("../components/About/aboutTeam"));

const AboutWith: React.FC = () => {
  const location = useLocation();
  const About = location.hash === "#aboutUs" ? location.hash  : "" ;
   useEffect(() => {
    if (!location.hash) return;

    let attempts = 0;
    const maxAttempts = 20;

    const scrollToHash = () => {
      const element = document.querySelector(location.hash);

      if (element) {
        const y =
          element.getBoundingClientRect().top +
          window.pageYOffset -
          120;

        window.scrollTo({
          top: y,
          behavior: "smooth",
        });
      } else if (attempts < maxAttempts) {
        attempts++;
        setTimeout(scrollToHash, 150); // retry
      }
    };

    // small delay to allow render
    setTimeout(scrollToHash, 100);

  }, [location.pathname, location.hash]);
  return (
    <>
      {/* Immediate load (important for LCP) */}
      <AboutBanner />
 
          <AboutusAbout  />
         
     
     
        <AboutFeature />
     
        <AboutMission />
     
        <AboutChairmanDetail />
     
        <AboutTeam />
     
    </>
  );
};

export default AboutWith;
